import { createSelector } from '@reduxjs/toolkit';
import { fetchApps } from './appsListActionCreators';
import collectEnabledFilters from '../common/collectEnabledFilters';
import { ACTION_TYPE } from '../../store/actionCreatorsHelpers';

const getEnabledFilters = createSelector([(state) => state.appsList.filters, (state) => state.user], (filters, user) =>
    collectEnabledFilters(filters, user)
);

const shouldRefreshAppsList = createSelector(
    [(state) => state.appsList.shouldUpdate, (state) => state.appsList.isFirstTime],
    (shouldUpdate, isFirstTime) => shouldUpdate || isFirstTime
);

export const refreshAppsList = createSelector(
    [
        shouldRefreshAppsList,
        (state) => state.appsList.search,
        getEnabledFilters,
        (state) => state.user.pageDomain,
        (state) => state.user.unifiedPlatform,
        (state) => state.appsList.queryParamPlatform,
        (state) => state.appsList.isInitialLoading,
    ],
    (should, search, enabledFilters, pageDomain, isUnifiedPlatform, queryParamPlatform, isInitialLoading) => {
        // If it is not unified platform and the initial load then set the platform
        // if isUnifiedPlatform -> fetch all apps, otherwise fetch platform specific
        if (isInitialLoading && queryParamPlatform && !isUnifiedPlatform) {
            return {
                type: ACTION_TYPE.PLATFORM_SELECT,
                platform: queryParamPlatform,
            };
        }

        if (should) {
            return fetchApps(enabledFilters, search, pageDomain);
        }
    }
);

export const refreshUnifiedPlatformAppsList = createSelector(
    [
        (state) => state.user.unifiedPlatform,
        (state) => state.user.exists,
        (state) => state.appsList.isFetching,
        (state) => state.appsList.isFirstTimeUnifiedPlatform,
    ],
    (unifiedPlatform, userExists, isFetching, isFirstTimeUnifiedPlatform) => {
        if (unifiedPlatform && userExists && !isFetching && isFirstTimeUnifiedPlatform) {
            return {
                type: ACTION_TYPE.UPDATE_APPS_FILTER,
                filterGroup: 'platform',
                filter: {
                    connect: false,
                    protect: false,
                },
            };
        }
    }
);
